(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var link = event.target.closest('#CartDrawer .cart__remove a');
    if (!link) return;
    event.preventDefault();
    var item = link.closest('.cart__item');
    if (!item) return;
    var stitchLabel = link.getAttribute('data-remove-stitch-label');
    var input = item.querySelector('.js-qty__num');
    if (!input) return;

    if (!stitchLabel) {
      input.value = 0;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    var parentKey = item.getAttribute('data-key');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = {};
        if (parentKey) updates[parentKey] = 0;
        (cart.items || []).forEach(function (line) {
          var title = line.product_title || line.title || '';
          if (!/get it stitched/i.test(title)) return;
          var matched = false;
          (line.options || []).forEach(function (value) {
            if (String(value || '').split('|')[0].trim() === stitchLabel) matched = true;
          });
          if (!matched && String(line.variant_title || '').indexOf(stitchLabel) !== -1) matched = true;
          if (matched || !(line.options || []).length) updates[line.key] = 0;
        });
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ updates: updates })
        });
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:build'));
      })
      .catch(function () {
        input.value = 0;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-images"] && !Shopify.designMode) return;
  try {
    function initProductMediaDots() {
    document.querySelectorAll('[data-product-photos]').forEach(function (slider) {
      var root = slider.closest('[data-product-images]');
      if (!root) return;

      var dots = root.querySelectorAll('[data-product-media-dot]');
      if (!dots.length) return;

      function bind(flkty) {
        if (!flkty || slider._mediaDotsFlkty === flkty) return;
        slider._mediaDotsFlkty = flkty;

        function sync() {
          var index = flkty.selectedIndex;
          dots.forEach(function (dot, i) {
            var selected = i === index;
            dot.classList.toggle('is-selected', selected);
            dot.setAttribute('aria-current', selected ? 'true' : 'false');
          });
        }

        flkty.on('select', sync);
        sync();

        dots.forEach(function (dot) {
          if (dot._mediaDotBound) return;
          dot._mediaDotBound = true;
          dot.addEventListener('click', function () {
            var i = parseInt(dot.getAttribute('data-index'), 10);
            if (!isNaN(i) && slider._mediaDotsFlkty) slider._mediaDotsFlkty.select(i);
          });
        });
      }

      function tryBind() {
        var flkty = window.Flickity && typeof Flickity.data === 'function' ? Flickity.data(slider) : null;
        if (flkty) {
          bind(flkty);
          return true;
        }
        return false;
      }

      if (tryBind()) return;

      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        if (tryBind() || tries > 40) clearInterval(timer);
      }, 250);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductMediaDots);
  } else {
    initProductMediaDots();
  }

  document.addEventListener('shopify:section:load', initProductMediaDots);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-template"] && !Shopify.designMode) return;
  try {
    function initStickyAddToCart() {
    var layout = document.querySelector('.product-page-layout');
    if (!layout) return;

    var original = layout.querySelector('[data-add-to-cart]');
    var sticky = document.querySelector('[data-product-atc-sticky]');
    if (!original || !sticky) return;
    if (sticky.dataset.bound === 'true') return;
    sticky.dataset.bound = 'true';

    var stickyBtn = sticky.querySelector('[data-product-atc-sticky-btn]');
    if (!stickyBtn) return;

    function sync() {
      stickyBtn.disabled = original.disabled;
      stickyBtn.innerHTML = original.innerHTML;
    }

    stickyBtn.addEventListener('click', function () {
      original.click();
    });

    sync();

    var mutation = new MutationObserver(sync);
    mutation.observe(original, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled']
    });

    if (!('IntersectionObserver' in window)) {
      sticky.classList.add('is-visible');
      layout.classList.add('is-atc-sticky');
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        var visible = entries[0].isIntersecting;
        sticky.classList.toggle('is-visible', !visible);
        layout.classList.toggle('is-atc-sticky', !visible);
      },
      { threshold: 0.15, rootMargin: '0px 0px -24px 0px' }
    );

    observer.observe(original);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAddToCart);
  } else {
    initStickyAddToCart();
  }

  document.addEventListener('shopify:section:load', initStickyAddToCart);
  } catch(e) { console.error(e); }
})();

})();
